import { db } from "../firebase";
import { doc, getDoc, setDoc } from "firebase/firestore";
import { COLLECTIONS } from "../models/collectionNames";
import { KoreanTextModel } from "../models";

/**
 * 지문 문서 ID 생성 (bookId_page_pageNumber)
 */
export const getParagraphDocId = (bookId: string, pageNumber: number): string => {
    return `${bookId}_page_${pageNumber}`;
};

/**
 * 지문 문서 기본/스태츠 초기화 헬퍼
 */
export const ensureParagraphDoc = async (
    bookId: string,
    pageNumber: number,
    title?: string
): Promise<KoreanTextModel> => {
    const docId = getParagraphDocId(bookId, pageNumber);
    const docRef = doc(db, COLLECTIONS.BOOK_UNIT, docId);
    const snap = await getDoc(docRef);

    if (snap.exists()) {
        return snap.data() as KoreanTextModel;
    }

    const newDoc: KoreanTextModel = {
        id: docId,
        bookId,
        title: title || `Page ${pageNumber}`,
        updatedAt: Date.now(),
        _stats: {
            conceptDone: false,
            analysisDone: false,
            questionsCount: 0,
            updatedAt: Date.now()
        }
    };

    await setDoc(docRef, newDoc);
    return newDoc;
};
